import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";
// Images
import defaultImage from "../../Images/profile.png"

import { apiService } from "../../Axios/apiService";

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import interactionPlugin from "@fullcalendar/interaction" // needed for dayClick

export default function ViewCalendar() {
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);

    const handleDateClick = (arg) => {
        console.log(arg.dateStr)
    }

    const handleEventClick = (clickInfo) => {
        console.log('Event clicked:', clickInfo.event)
        navigate(`/projects/view/${clickInfo.event.extendedProps.projectId}`)
    }

    function renderEventContent(eventInfo) {
        const type = eventInfo.event.extendedProps.type;

        const styleMap = {
            activeTask: { backgroundColor: "lightblue" },
            completedTask: { backgroundColor: "lightgreen" },
            anniversary: { backgroundColor: "lightgrey" }
        };

        return (
            <div style={styleMap[type]}>
                <b>{eventInfo.timeText}</b>
                <i style={{ color: "black" }}>{eventInfo.event.title}</i>
            </div>
        );
    }

    


    const handleDatesSet = (dateInfo) => {
        console.log("dateInfo", dateInfo);

        apiService("get", `events/?startDate=${dateInfo.start.toISOString()}&endDate=${dateInfo.end.toISOString()}`, null,
            (response) => {
                console.log("Events:", response);

                // map the response to the format FullCalendar expects
                const events = response.map(task => ({
                    title: task.title,
                    start: task.date,
                    allDay: true,
                    extendedProps: {
                        type: task.type, // e.g., "activetask" or "completedtask"
                        projectId: task.projectId
                    }
                }));

                console.log("Mapped Events:", events);

                setEvents(events);
            },
            (error) => {
                
            }
        )

    }

    const styles = {
        calendarevent_activeTask: {
            backgroundColor: "lightblue",
            color: "black"
        },
        calendarevent_completedTask: {
            backgroundColor: "lightgreen"
        },
    }

    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    <FullCalendar
                        plugins={[dayGridPlugin, interactionPlugin]}
                        eventContent={renderEventContent}
                        initialView="dayGridMonth"
                        events={events}
                        dateClick={handleDateClick}
                        datesSet={handleDatesSet}
                        eventClick={handleEventClick}
                    />
                </div>
            </div>
        </div>
    )

    
}
